export default __webpack_public_path__ + "img/default-img.167de07f.jpg";